import listActions from 'src/modules/ubicacion/list/ubicacionListActions';
import UbicacionService from 'src/modules/ubicacion/ubicacionService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'UBICACION_DESTROY';

const ubicacionDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: ubicacionDestroyActions.DESTROY_STARTED,
      });

      await UbicacionService.destroyAll([id]);

      dispatch({
        type: ubicacionDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.ubicacion.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/ubicacion');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: ubicacionDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: ubicacionDestroyActions.DESTROY_ALL_STARTED,
      });

      await UbicacionService.destroyAll(ids);

      dispatch({
        type: ubicacionDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.ubicacion.destroyAll.success'),
      );

      getHistory().push('/ubicacion');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: ubicacionDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default ubicacionDestroyActions;
